import styles from './campaign-module.module.scss';
import { BASE_IMAGE_URL } from '../constants';
import { parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import Tooltip from '../tooltip/tooltip';

export const FOLDER_COLORS = {
  DEFAULT: '#E8FDAC',
  TSY_HOUSE_AD: '#E3FAF2',
  CASH_ACCOUNT_AD: '#FFFFFF',
};

const CASH_ACCOUNT_TITLE = (
  <span>
    Earn{' '}
    <Tooltip
      trigger="4.65% APY"
      content="The boosted 4.65% Annual Percentage Yield (APY) is offered on up to $250,000 in deposits for the first 6 months when you open a Cash Account offered by Atomic Brokerage LLC and deposit funds within 14 days. Balances above $250,000 will earn the standard 4.00% APY. After the 6 month introductory period, all balances will earn the standard 4.00% APY. The 4.65% boosted introductory APY is available through NerdWallet’s promotional program. APYs are accurate as of 07/14/2025 and are subject to change without notice."
    ></Tooltip>{' '}
    on your cash
  </span>
);

export const CAMPAIGN_MODULE_COPIES = {
  DEFAULT: {
    title: 'Get cash rewards for being smart with your finances',
    subtitle:
      'It’s free to collect points for smart moves like monitoring your credit score. Upgrade to NerdWallet+ for $49/year to earn up to $599/year in cash rewards.*',
    ctaCopy: 'START FOR FREE',
    terms: '*$599 is max rewards value if you join NerdWallet+ for $49/year.',
    images: {
      desktop: {
        src: `${BASE_IMAGE_URL}/superbowl/heroes/NPlus-599-375.png`,
        width: 611,
        height: 445,
      },
      tablet: {
        src: `${BASE_IMAGE_URL}/superbowl/heroes/NPlus-599-768.png`,
        width: 365,
        height: 435,
      },
      mobile: {
        src: `${BASE_IMAGE_URL}/superbowl/heroes/NPlus-599-1440.png`,
        width: 343,
        height: 320,
      },
    },
  },
  TSY_HOUSE_AD: {
    title: (apy?: number) => {
      if (apy !== undefined) {
        return (
          <span>
            Earn {apy.toFixed(2) + '%'} APY by investing in U.S. Treasury Bills*
          </span>
        );
      }

      return (
        <span>
          Earn <span className={styles.shimmerApy}></span> APY by investing in
          U.S. Treasury Bills*
        </span>
      );
    },
    subtitle:
      'Maximize your cash by investing in low-risk, government-backed T-Bills. All the work is done for you — just make the deposit and watch your money grow.',
    ctaCopy: 'LEARN MORE',
    terms: (date?: string) => {
      if (date) {
        const parsedDate = parseISO(date);
        const formattedDate = formatInTimeZone(parsedDate, 'UTC', 'MM/dd/yyyy');
        return `*Rate when held to maturity for a T-Bill maturing in one month as of ${formattedDate}. Rate shown is subject to price fluctuations.`;
      }
    },
    images: {
      desktop: {
        src: 'https://www.nerdwallet.com/cdn/front-page-next/tsy-house-ad-desktop-updated-2x.png',
        width: 1127,
        height: 821,
      },
      tablet: {
        src: 'https://www.nerdwallet.com/cdn/front-page-next/tsy-house-ad-tablet-updated-2x.png',
        width: 640,
        height: 732,
      },
      mobile: {
        src: 'https://www.nerdwallet.com/cdn/front-page-next/tsy-house-ad-mobile-updated-2x.png',
        width: 686,
        height: 564,
      },
    },
  },
  CASH_ACCOUNT_AD: {
    title: CASH_ACCOUNT_TITLE,
    subtitle:
      'Boost your APY for 6 months with a Cash Account offered by Atomic Brokerage. You can build up your emergency fund or stay flexible, withdrawing whenever you need without penalties or account minimums. Just deposit funds within 14 days so you can earn a boosted 4.65% APY on balances up to $250,000 for the first 6 months.',
    ctaCopy: 'LEARN MORE',
    terms: 'Paid Non-Client Promotion',
    images: {
      desktop: {
        src: `${BASE_IMAGE_URL}/cash_account_desktop_2x.png`,
        width: 1098,
        height: 697,
      },
      tablet: {
        src: `${BASE_IMAGE_URL}/cash_account_tablet_2x.png`,
        width: 1328,
        height: 591,
      },
      mobile: {
        src: `${BASE_IMAGE_URL}/cash_account_mobile_2x.png`,
        width: 686,
        height: 561,
      },
    },
  },
};
